<template>
  <div>
    <header class="ga-header mdl-layout__header">
      <div class="mdl-layout__header-row">
        <!-- Title -->
        <div class="logo" v-on:click="master"></div>
        <span v-if="logged" class="ga-title mdl-layout-title mdl-typography--font-light">{{toName}}</span>
        <span v-else class="ga-title ga-hand mdl-layout-title mdl-typography--font-light" v-on:click="master">{{'general.application.title' | label}}</span>
        <div class="ga-header-spacer mdl-layout-spacer" ></div>
        <div v-if="!logged && !isLoginPage" class="nav ga-search-box mdl-textfield--align-right">
          <div id="login-link" class="button" @click="goToLogin()">{{{"master.header.login" | label}}}</div>
        </div>
        <div v-if="!logged" class="ga-search-box mdl-textfield--align-right " >
          <mdl-select img name='lang' :value.sync="lang" options="LANG"></mdl-select>
        </div>
        <!--<div class="ga-search-box mdl-textfield&#45;&#45;align-right " >-->
          <!--&lt;!&ndash; Colored FAB button with ripple &ndash;&gt;-->
          <!--<button class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;mini-fab">-->
            <!--?-->
          <!--</button>-->
        <!--</div>-->

        <!-- Tabs -->
        <div  class="ga-navigation-container">
          <nav class="ga-navigation mdl-navigation">
            <a v-for="item in menu"
              v-link="{
                path: item.path,
                activeClass: 'is-active'
              }" class="mdl-navigation__link mdl-typography--text-uppercase">{{item.label | label}}</a>
            <a v-if="logged" class="mdl-navigation__link mdl-typography--text-uppercase" v-on:click="$dispatch('logout')">
              {{ 'general.application.logout' | label }}
            </a>
          </nav>
        </div>
          <div class="mobile-menu" :style="{'display':menuOpen ? 'flex !important' : 'none!important'}">
          <nav class="ga-navigation mdl-navigation">
            <a v-on:click="openMenu" v-for="item in menu"
              v-link="{
                path: item.path,
                activeClass: 'is-active'
              }" class="mdl-navigation__link mdl-typography--text-uppercase">{{item.label | label}}</a>
            <a v-if="logged" class="mdl-navigation__link mdl-typography--text-uppercase" v-on:click="doLogout">
              {{ 'general.application.logout' | label }}
            </a>
          </nav>
        </div>
        <div v-if="logged" style="width: 100px;height: 100%; z-index:100;" v-on:click="openMenu">
        <button  class="mobile mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
        >
          <i :class="{'show-button': !menuOpen, 'close':menuOpen}" class="material-icons">menu</i>
          <i :class="{'show-button': menuOpen, 'close':!menuOpen}" class="material-icons close">close</i>
        </button>
        </div>
      </div>

    </header>

    <div id="ga-drawer" class="ga-drawer mdl-layout__drawer">
      <span   class="ga-title mdl-layout-title mdl-typography--font-light">{{'general.application.title' | label}}</span>

      <div class="mdl-navigation">
        <a v-for="item in menu"
        v-link="{
        path: item.path,
        activeClass: 'is-active'
      }" class="drawer-link mdl-navigation__link mdl-typography--text-uppercase">{{item.label | label}}</a>
        <a v-if="logged" class="mdl-navigation__link mdl-typography--text-uppercase" v-on:click="$dispatch('logout')">
        {{ 'general.application.logout' | label }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
var transform = function (elem) {
  return {label: elem.label, path: elem.value}
}
var getters = require('common/store/getters')
var actions = require('common/store/actions')
var config = require('common/config')

module.exports = {
  ready: function () {
  },
  components: {
    mdlSelect: require('c/components/Select')
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  props: ['defaultLang'],
  methods: {
    openMenu: function () {
      this.menuOpen = !this.menuOpen
    },
    master: function () {
      window.open(config.master, '_self')
    },
    goToLogin () {
      this.$router.go('/app/login')
    },
    doLogout: function () {
      var self = this
      this.openMenu()
      setTimeout(() => self.$dispatch('logout'), 500)
    }

  },
//  watch: {
//    lang: function (val) {
//      console.log('lang change triggered - watch')
//      this.changeLanguage(val)
//    }
//  },
  computed: {
    menu: function () {
      var lang = this.language
      console.log(lang)
      var menuList = []
      if (this.logged) {
        menuList = this.$options.filters.lookup('MENU_USER').map(transform)
      }
      return menuList
    },
    lang: {
      get: function () {
        return this.language
      },
      set: function (val) {
        this.changeLanguage(val).then(function () {
          var split = location.href.split('?lang=')
          location.href = split[0] + '?lang=' + val
        }) // this.$dispatch('lang-changed', val))
      }
    },
    isLoginPage: function () {
      return this.$route.path === '/app/login'
    },
    toName: function () {
      let toName = [this.user.firstName, this.user.lastName]
        .filter(item => item)
        .join(' ') || this.user.nickname
      return toName
    }
  },
  data () {
    return {
      menuOpen: false
    }
  }
}
</script>

<style scoped>

.rtl .mdl-layout__header-row{
  padding: 0 72px 0 16px !important;
}


.rtl .mobile{
  margin-right: auto;
  flex-direction: row-reverse!important;
}
.mobile{
  display:none;
}
.mdl-button--icon{
  height: 56px;
  width: 56px;
}
.mobile-menu{
  position: absolute;
  display:none !important;
  height:100vh;
  z-index: 99;
  top: 0;
  right: 0;
  width: 100%;
  background-color: #52757a;
  justify-content: center;
  align-items: center;

 }
 .mobile-menu nav{
  display: flex;
  flex-direction:column;

 }
 .close{
  display: none !important;
 }
 .show-button{
  z-index: 100;
  position: relative;
display: block!important;
 }
 @media (max-width: 900px) {
  .mobile{
    display: flex !important;
  }

 }

  .ga-search-box {
    width: 100px;
    padding-top: 5px;
  }

  div.nav {
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    margin: auto;
  }

  div.nav .button {
    background-color: #e3e3e3;
    margin: 1em;
    /* padding: 0.3em 1.5em; */
    border: 1px solid #52757a;
    cursor: pointer;
    color: #52757a;
    border-radius: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Heading.vue?189833fb